function Loading() {
  return (
    <div className="loading">
      <div className="logo">
        <div className="logo--tr"></div>
        <div className="logo--tl"></div>
        <div className="logo--l"></div>
        <div className="logo--r"></div>
        <div className="logo--br"></div>
        <div className="logo--bl"></div>
        <div className="logo--jt"></div>
        <div className="logo--jb"></div>
        <div className="logo--lt"></div>
        <div className="logo--lb"></div>
      </div>
    </div>
  );
}

export default Loading;
